export default __webpack_public_path__ + "media/products/collect-1e537a12.png";